import { Component, OnInit } from '@angular/core';
import { FileUploader,FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals } from '../../globals';


@Component({
  selector: 'app-evaluate-answer-upload',
  templateUrl: './evaluate-answer-upload.component.html',
  styleUrls: ['./evaluate-answer-upload.component.css']
})
export class EvaluateAnswerUploadComponent implements OnInit {
  hasBaseDropZoneOver:boolean;
  hasAnotherDropZoneOver:boolean;
  response:string;
  
  constructor (private global : Globals){
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
  }

  attachmentUrl =this.global.siteUrl+'file/bulkupload?folder='+this.global.tsAnsFolder+'&mediaFor=studentEvaluation';
  uploader:FileUploader=new FileUploader({url:this.attachmentUrl,maxFileSize: 100*1024*1024});
 
  public fileOverBase(e:any):void {
    this.uploader.uploadAll();
    this.hasBaseDropZoneOver = e;
  }
 
  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false
   });
  }

  ngOnInit() {
    this.uploader.onBeforeUploadItem = (fileItem: any) => {
      if(this.chekValidFile(fileItem.file.name)){
        fileItem['isMsg']="Processing...";
      }else{
        this.uploader.removeFromQueue(fileItem);
         throw new Error('Please upload valid format filename');
      }
     };
  }

   chekValidFile(data){
    var arrayData =  data.split("_");
    if(Array.isArray(arrayData) && arrayData.length==4){
        if(typeof arrayData[0]!="string"){
          return false;
        }
        return true;
    }else{
    return false;
    }
    
    }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any { 
      let data = JSON.parse(response); //success server response  
        if(data.error==0){
          item.isSuccess=true;
          item['isSuccessMsg'] ='Done';
        }else{
          item.isError=true;
          item.progress=0;
          item['isErrorMsg'] =data.message;
        }
    }
  
    onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
       alert("Please upload valid format filename:"+item.file.name);
      }

      onFileChanged(event) {
        this.uploader.uploadAll();
       }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/evaluate-answer-upload/evaluate-answer-upload.component.ts